(() => {
  if (customElements.get('kd-hp-greenspark')) return;

  // Same public Shopify connection and endpoint used by the Greenspark app SDK.
  // Read only the returned metric text; never insert third-party HTML or scripts.
  const requests = new Map();
  const metrics = ['straws', 'miles', 'monthsEarthPositive'];

  function loadImpact(integration) {
    if (requests.has(integration)) return requests.get(integration);
    const request = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch('https://api.getgreenspark.com/v2/widgets/full-width-banner?lng=en', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-integration-slug': integration
          },
          body: JSON.stringify({ options: metrics }),
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Greenspark widget unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const amounts = [...document.querySelectorAll('.greenspark-option-amount')];
        const labels = [...document.querySelectorAll('.greenspark-option-text')];
        const expected = [/plastic straws/i, /miles of driving/i, /months earth positive/i];
        if (amounts.length !== metrics.length || labels.length !== metrics.length) {
          throw new Error('Greenspark widget markup changed');
        }
        return Object.fromEntries(metrics.map((metric, index) => {
          const value = amounts[index].textContent.trim();
          if (!expected[index].test(labels[index].textContent) || !/^\d[\d,.\s]*(?:million|billion|thousand)?$/i.test(value)) {
            throw new Error('Unexpected Greenspark metric');
          }
          return [metric, value];
        }));
      } finally {
        clearTimeout(timeout);
      }
    })();
    requests.set(integration, request);
    request.catch(() => requests.delete(integration));
    return request;
  }

  customElements.define('kd-hp-greenspark', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.live !== 'true' || !this.dataset.integration) return;
      loadImpact(this.dataset.integration).then(values => {
        if (!this.isConnected) return;
        this.querySelectorAll('[data-metric]').forEach(card => {
          const value = values[card.dataset.metric];
          if (value) card.querySelector('[data-value]').textContent = value;
        });
      }).catch(() => {
        // Merchant-editable fallback figures stay visible if the service fails.
      });
    }
  });
})();
